module.exports = __webpack_public_path__ + "static/media/logo-hispanos.6e1b6116.png";